module.exports = __webpack_public_path__ + "media/theme/iTunes-8e792d72.png";